var hooxSliderReviews = document.querySelector(".hoox-reviews__slider-reviews");

if (hooxSliderReviews) {
  var slider = new Swiper(hooxSliderReviews, {
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    centeredSlides: true,
    spaceBetween: 10,
    breakpoints: {
      767: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 5,
        centeredSlides: true
      },
    },
    pagination: {
      el: '.hoox-reviews__dots',
      clickable: true,
    },
    navigation: {
      nextEl: ".hoox-swiper-arrow-next",
      prevEl: ".hoox-swiper-arrow-prev",
    },
  });
}
